import React from "react";
import { Box, Container, Typography } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        backgroundColor: "#ffff",
        pt: { xs: 3, sm: 4, md: 5 },
        pb: { xs: 4, sm: 5, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h1"
          align="center"
          sx={{
            fontWeight: 500,
            color: "#000",
            mb: { xs: 3, md: 4 },
            fontSize: {
              xs: "1.5rem",
              sm: "1.5rem",
              md: "2rem",
            },
          }}
        >
          Privacy Policy
        </Typography>

        <Box
          sx={{
            maxWidth: "1600px",
            mx: "auto",
          }}
        >
          <Typography
            sx={{
              color: "#000",
              lineHeight: 1.8,
              fontSize: {
                xs: "10px",
                sm: "12px",
                md: "14px",
              },
              mb: 4,
            }}
          >
            This website does not automatically capture any specific personal
            information from you (like name, phone number or e-mail address)
            that allows us to identify you individually.
            <br />
            Wherever the Website requests you to provide personal information,
            you will be informed for the particular purposes for which the
            information is gathered and adequate security measures will be taken
            to protect your personal information.
            <br />
            We do not sell or share any personally identifiable information
            volunteered on the website to any third party (public/private).
            Any information provided to this website will be protected from
            loss, misuse, unauthorized access or disclosure, alteration, or
            destruction.
          </Typography>

          <Typography
            sx={{
              color: "#000",
              lineHeight: 1.8,
              fontSize: {
                xs: "10px",
                sm: "12px",
                md: "14px",
              },
            }}
          >
            We gather certain information about the User, such as Internet
            protocol (IP) addresses, domain name, browser type, operating
            system, the date and time of the visit and the pages visited. We
            make no attempt to link these addresses with the identity of
            individuals visiting our website unless an attempt to damage the
            website has been detected.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;